$icon-font-path: "~bootstrap-sass/assets/fonts/bootstrap/";
$fa-font-path: "~font-awesome/fonts";

// IDS Light theme (iress-theme-light)
// =====================

@import "./styles/dummy-brands/iress_bank";
@import "../node_modules/@iress/client-portal-themes/dist/ids--light/_variables";
$fa-font-path: "~font-awesome/fonts"; /* Dev file path  */
$roboto-font-path: "~roboto-fontface/fonts"; /* Dev file path  */
@import "./styles/_after-brand";
@import "../node_modules/@iress/client-portal-themes/dist/ids--light/_core";
@import "../node_modules/@iress/client-portal-themes/dist/ids--light/_colours";
@import "./styles/theme-overrides/ids-light/_theme";
